import { useDeleteObjectiveAttribute } from '@/api/glow-up/glow-up.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { ObjectiveAttribute } from '@repo/types/src/glow-up';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

type DeleteObjectiveAttributeProps = {
  attribute: ObjectiveAttribute;
  refetch: () => void;
};

export const DeleteObjectiveAttribute = ({
  attribute,
  refetch,
}: DeleteObjectiveAttributeProps) => {
  const mutation = useDeleteObjectiveAttribute();
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    mutation.mutate(attribute.id, {
      onSuccess: () => {
        setOpen(false);
        refetch();
        toast.success(
          `L’attribut d’objectif "${attribute.name}" a été supprimé`,
          { duration: 3000 },
        );
      },
      onError: () => {
        toast.error(
          `Erreur lors de la suppression de l’attribut "${attribute.name}"`,
          { duration: 3000 },
        );
      },
    });
  };

  const isLoading = mutation.isPending;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" disabled={isLoading}>
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">
            Supprimer l’attribut
          </DialogTitle>
          <DialogDescription className="text-center">
            Voulez-vous vraiment supprimer l’attribut "{attribute.name}" ?
            Cette action est irréversible.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost" disabled={isLoading}>
              Annuler
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
          >
            {isLoading ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
